import { useMediaQuery } from 'react-responsive';

import AnimatedRobot from '@/components/atom/AnimatedRobot/AnimatedRobot';
import AnimatedRobotSpeechBubble from '@/components/molecule/AnimatedRobotSpeechBubble/AnimatedRobotSpeechBubble';
import {Container} from "@/components/organism/FeedbackInfoSidebar/FeedbackInfoSidebar.styles";
import { useAppDispatch } from '@/configuration/setup/hooks';
import { toggleSidebar } from '@/store/sidebar/sidebarSlice';

const FeedbackInfoSidebar = () => {
  const dispatch = useAppDispatch();
  const isSmallScreen = useMediaQuery({ query: '(max-width: 47.5rem)' });

  const texts = {
    titlePartOne: 'feedbackPage.sidebar.title.partOne',
    descriptionPartOne: 'feedbackPage.sidebar.description.partOne',
    descriptionPartTwo: 'feedbackPage.sidebar.description.partTwo',
    button: 'feedbackPage.sidebar.description.partTwo.button',
  } as const;

  const handleCloseSidebar = () => dispatch(toggleSidebar());

  const messages = [
    {
      title: texts.titlePartOne,
      text: texts.descriptionPartOne,
    },
    {
      text: texts.descriptionPartTwo,
      ...(isSmallScreen
        ? {
            buttons: [
              {
                text: texts.button,
                onClick: handleCloseSidebar,
              },
            ],
          }
        : {}),
    },
  ];

  return (
    <Container>
      <div>
        <AnimatedRobotSpeechBubble messages={messages} />
        <AnimatedRobot isVisible />
      </div>
    </Container>
  );
};

export default FeedbackInfoSidebar;
